import {
  rescueDetectionRequestSchema,
  rescueDetectionResponseSchema,
  rescueEvidenceAnalysisRequestSchema,
  rescueEvidenceAnalysisResponseSchema,
  launchRescueRequestSchema,
  launchRescueResponseSchema,
  rescueCaseSchema,
  rescueListResponseSchema,
  updateRescueCommitmentRequestSchema,
  updateRescueCommitmentResponseSchema,
  type LaunchRescueResponse,
  type RescueCase,
  type RescueDetectionRequest,
  type RescueDetectionResponse,
  type RescueEvidenceAnalysisRequest,
  type RescueEvidenceAnalysisResponse,
  type RescueListResponse,
  type UpdateRescueCommitmentRequest,
  type UpdateRescueCommitmentResponse,
} from "@io-spoke/contracts/rescue";
import { getApiClient } from "./apiClient";

export async function getRescueCases(): Promise<RescueListResponse> {
  const response = await getApiClient().get("/rescues");
  const parsed = rescueListResponseSchema.safeParse(response.data);
  if (!parsed.success) throw new Error("Rescue Radar returned an invalid response.");
  return parsed.data;
}

export async function getRescueCase(id: string): Promise<RescueCase> {
  const response = await getApiClient().get(`/rescues/${encodeURIComponent(id)}`);
  const parsed = rescueCaseSchema.safeParse(response.data);
  if (!parsed.success) throw new Error("Rescue case returned an invalid response.");
  return parsed.data;
}

export async function launchRescue(id: string): Promise<LaunchRescueResponse> {
  const payload = launchRescueRequestSchema.parse({ approved: true });
  const response = await getApiClient().post(`/rescues/${encodeURIComponent(id)}/launch`, payload);
  const parsed = launchRescueResponseSchema.safeParse(response.data);
  if (!parsed.success) throw new Error("Launch Rescue returned an invalid response.");
  return parsed.data;
}

export async function detectRescue(input: RescueDetectionRequest): Promise<RescueDetectionResponse> {
  const payload = rescueDetectionRequestSchema.parse(input);
  const response = await getApiClient().post("/rescues/detect", payload);
  const parsed = rescueDetectionResponseSchema.safeParse(response.data);
  if (!parsed.success) throw new Error("Rescue detection returned an invalid response.");
  return parsed.data;
}

export async function analyzeRescueEvidence(
  rescueCaseId: string,
  input: RescueEvidenceAnalysisRequest
): Promise<RescueEvidenceAnalysisResponse> {
  const payload = rescueEvidenceAnalysisRequestSchema.parse(input);
  const response = await getApiClient().post(`/rescues/${encodeURIComponent(rescueCaseId)}/analyze-evidence`, payload);
  const parsed = rescueEvidenceAnalysisResponseSchema.safeParse(response.data);
  if (!parsed.success) throw new Error("Evidence Lab returned an invalid response.");
  return parsed.data;
}

export async function updateRescueCommitment(
  rescueCaseId: string,
  commitmentId: string,
  input: UpdateRescueCommitmentRequest
): Promise<UpdateRescueCommitmentResponse> {
  const payload = updateRescueCommitmentRequestSchema.parse(input);
  const response = await getApiClient().patch(
    `/rescues/${encodeURIComponent(rescueCaseId)}/commitments/${encodeURIComponent(commitmentId)}`,
    payload
  );
  const parsed = updateRescueCommitmentResponseSchema.safeParse(response.data);
  if (!parsed.success) throw new Error("Promise Ledger returned an invalid response.");
  return parsed.data;
}
